"use client";
import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

function adjustColorToVariant(options: Map<string, unknown>) {
  if (options.get("variant") === "redirect" && options.get("color") === "ghost") {
    options.set("color", "primary");
    alert(`Redirect variant does not support "ghost" color`);
  }
}

export const ctaInputs = [
  {
    name: "label",
    type: "string",
    defaultValue: "CTA label",
    required: true,
  },
  {
    name: "url",
    type: "url",
    defaultValue: "#ploom",
    required: true,
  },
  {
    name: "variant",
    type: "string",
    enum: ["redirect", "cta"],
    defaultValue: "cta",
    required: true,
    onChange: adjustColorToVariant,
  },
  {
    name: "color",
    type: "string",
    enum: ["primary", "secondary", "tertiary", "quaternary", "ghost"],
    defaultValue: "primary",
    required: true,
    onChange: adjustColorToVariant,
  },
  {
    name: "alignment",
    type: "string",
    enum: ["start", "center", "end"],
    defaultValue: "center",
  },
  {
    name: "trackingEvent",
    friendlyName: "Tracking event",
    type: "string",
    enum: [
      { label: "None", value: "" },
      { label: "CTA Click", value: "cta_click" },
      { label: "Free trial click", value: "free_trial_click" },
      { label: "Ploom club click", value: "ploom_club_click" },
      { label: "Consumer care click", value: "consumer_care_click" },
      { label: "Contact click", value: "contact_click" },
      { label: "Phone click", value: "phone_click" },
      { label: "Search", value: "search" },
      { label: "Follow", value: "follow" },
    ],
    defaultValue: "",
  },
] as const satisfies Inputs;

export const CtaComponent: RegisteredComponent = {
  name: "CTA",
  component: withValidation(
    ctaInputs,
    dynamic(() => import("./Cta").then((mod) => mod.Cta)),
    "CTA"
  ),
  inputs: ctaInputs,
};
